module.exports = __webpack_public_path__ + "static/ha-couple-041ce27f3c55823ab6d6aef4c46fd66a.jpg";